/* THE CLIQUE — Beymen tarzi koleksiyon filtre paneli (TASLAK)
   FILTRE butonuna basinca paneli butonun altina acar (masaustu, >=1025px).
   Sayfa KILITLENMEZ; panel acikken sayfa serbestce kaydirilabilir, panel
   butona yapisik kalir (scroll ile yeniden konumlanir). Disari tikla / X / ESC kapatir.
   Mobilde temanin kendi drawer'i calismaya devam eder. */
(function () {
  var DESK = function () { return true; };  // mobil dahil tum ekranlarda drawer
  function isOpen() { return document.body.classList.contains('tcb-filter-open'); }
  function panelEl() { return document.querySelector('.collection-full-width #halo-sidebar') || document.querySelector('#halo-sidebar'); }
  function btnEl() { return document.querySelector('.collection-full-width .toolbar .toolbar-sidebar') || document.querySelector('.toolbar .toolbar-sidebar'); }

  function positionPanel() {
    var btn = btnEl(), panel = panelEl();
    if (!btn || !panel) return;
    var r = btn.getBoundingClientRect();
    var w = Math.min(720, window.innerWidth * 0.94);
    var left = r.left;
    if (left + w > window.innerWidth - 12) left = window.innerWidth - w - 12;
    panel.style.top = (r.bottom + 8) + 'px';
    panel.style.left = Math.max(12, left) + 'px';
    panel.style.maxHeight = Math.max(220, window.innerHeight - r.bottom - 28) + 'px';
  }
  function openF() { positionPanel(); document.body.classList.add('tcb-filter-open'); }
  function closeF() { document.body.classList.remove('tcb-filter-open'); }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.toolbar-sidebar, .toolbar-icon.icon-filter');
    if (trigger && DESK()) {
      e.preventDefault(); e.stopPropagation();
      if (isOpen()) closeF(); else openF();
      return;
    }
    if (e.target.closest('.halo-sidebar-close, [data-close-sidebar]')) { closeF(); return; }
    // panel disina tiklayinca kapat (sayfa etkilesimini engellemeden)
    if (isOpen() && DESK()) {
      var p = panelEl();
      if (p && !p.contains(e.target)) closeF();
    }
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeF(); });

  // panel acikken sayfa kaydirilinca butona yapisik kalsin
  var ticking = false;
  function follow() {
    if (!isOpen() || !DESK()) return;
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { positionPanel(); ticking = false; });
  }
  window.addEventListener('scroll', follow, { passive: true });
  window.addEventListener('resize', follow);
})();


/* ===================== TC FILTER TABS — FAZ 1 (?ftabs=1 ile gated) =====================
   Filtre panelini "sol sabit sekme listesi + sag icerik" modal duzene cevirir (mockup).
   Sabit iskelet kurulur; filtre bloklari geldikce ilgili sekmeye senkronize tasinir
   (gec gelen custom bloklar icin re-sync). Sadece ?ftabs=1 varken aktif. */
(function () {
  // YAYINDA: tum ziyaretciler icin aktif. Kill-switch: ?ftabs=0 ile devre disi birakilabilir (acil durum).
  function gated() { try { return !/[?&]ftabs=0(?:&|$)/.test(location.search); } catch (e) { return true; } }
  if (!gated()) return;
  var FTEST = /[?&]ftabs=1(?:&|$)/.test(location.search); // test: panel otomatik acilsin (yayinda FILTRELE butonu acar)

  // Dil: theclique.shop = tr (Turkiye), theclique.shop/en = en (yurtdisi). Native fasetleri Shopify cevirir;
  // bizim enjekte ettigimiz tum metinler burada lokalize edilir.
  var LANG = 'tr';
  try { LANG = ((window.Shopify && Shopify.locale) || document.documentElement.lang || 'tr'); } catch (e) {}
  var EN = LANG.slice(0, 2).toLowerCase() !== 'tr';
  function L(tr, en) { return EN ? en : tr; }

  var TABS = [
    { k: 'marka', t: 'MARKA', e: 'BRAND' }, { k: 'cinsiyet', t: 'CİNSİYET', e: 'GENDER' }, { k: 'kategori', t: 'KATEGORİ', e: 'CATEGORY' },
    { k: 'beden', t: 'BEDEN', e: 'SIZE' }, { k: 'renk', t: 'RENK', e: 'COLOR' }, { k: 'fiyat', t: 'FİYAT', e: 'PRICE' },
    { k: 'nota', t: 'NOTA', e: 'NOTES' }, { k: 'stil', t: 'STİL TÜRÜ', e: 'STYLE' },
    { k: 'ortam', t: 'ORTAMA GÖRE', e: 'OCCASION' }, { k: 'kordon', t: 'KORDON TİPİ', e: 'STRAP TYPE' },
    { k: 'stok', t: 'STOK DURUMU', e: 'AVAILABILITY' }
  ];
  var KW = {
    marka: ['marka', 'brand'], fiyat: ['fiyat', 'price'], stok: ['stok', 'avail', 'durum'],
    beden: ['beden', 'size'], renk: ['renk', 'color'], nota: ['nota', 'note'],
    stil: ['stil', 'style'], ortam: ['ortam'], kordon: ['kordon', 'kayis', 'strap'],
    cinsiyet: ['cinsiyet', 'gender'], kategori: ['kategori', 'category']
  };
  function norm(s) {
    // ONCE Turkce harfleri cevir (JS "İ".toLowerCase() -> birlesik noktali i, eslesmeyi bozar), SONRA kucult
    var m = { 'ı': 'i', 'İ': 'i', 'I': 'i', 'ş': 's', 'Ş': 's', 'ğ': 'g', 'Ğ': 'g', 'ü': 'u', 'Ü': 'u', 'ö': 'o', 'Ö': 'o', 'ç': 'c', 'Ç': 'c' };
    return (s || '').replace(/[ıİIşŞğĞüÜöÖçÇ]/g, function (c) { return m[c] || c; }).toLowerCase().trim();
  }
  function keyOf(title) { var t = norm(title); for (var k in KW) { for (var i = 0; i < KW[k].length; i++) { if (t.indexOf(KW[k][i]) > -1) return k; } } return 'genel'; }
  // native filtre formunun TUM secili degerlerini (Marka/Fiyat/Stokta) query'e serialize et -> path-tag navigasyonunda ezilmesin
  function nativeQS() {
    // 1) URL'deki mevcut filter parametreleri (AJAX state) -> ONCELIK
    var p = new URLSearchParams();
    try { new URLSearchParams(location.search).forEach(function (v, k) { if (k.indexOf('filter.') === 0) p.append(k, v); }); } catch (e) {}
    // 2) URL'de olmayan (default Stokta gibi) secimleri form'dan tamamla
    var form = document.getElementById('CollectionFiltersForm');
    if (form) { try { new FormData(form).forEach(function (v, k) { if (k && k.indexOf('filter.') === 0 && v !== '' && !p.has(k)) p.append(k, v); }); } catch (e) {} }
    if (FTEST) p.set('ftabs', '1');   // sadece testte ftabs koru; yayinda temiz URL
    return p.toString();
  }
  function titleOf(b) {
    var c = b.querySelector('.tcb-flt-title'); if (c) return c.textContent.trim();
    var h = b.querySelector('.facets__text'); if (h) return h.textContent.trim();
    var h2 = b.querySelector('.sidebarBlock-heading'); return h2 ? h2.textContent.trim() : '';
  }
  function collectBlocks(sb) {
    var out = [];
    sb.querySelectorAll('.collection-filters__item.facets__wrapper .sidebarBlock.js-filter').forEach(function (b) {
      if (!b.classList.contains('refined-widgets')) out.push(b);
    });
    sb.querySelectorAll('.sidebar-custom-text').forEach(function (b) { if (b.querySelector('.tcb-flt-title')) out.push(b); });
    return out;
  }
  function activate(rail, body, btn, pane) {
    rail.querySelectorAll('.tcft-tab').forEach(function (t) { t.classList.remove('is-active'); });
    body.querySelectorAll('.tcft-pane').forEach(function (p) { p.classList.remove('is-active'); });
    btn.classList.add('is-active'); pane.classList.add('is-active');
  }

  function ensure() {
    var sb = document.getElementById('halo-sidebar'); if (!sb) return;
    var wrap = sb.querySelector('.halo-sidebar-wrapper'); if (!wrap) return;
    document.body.classList.add('tc-ftabs');
    var handle = (location.pathname.match(/collections\/([^\/?]+)/) || [])[1] || '';
    // panel basligi (FİLTRELE/FILTER) ve kapatma yazisi CSS .title::after ile lokalize edilir (tab_addon.css)
    var header = sb.querySelector('.halo-sidebar-header');
    // header'a "Tumunu Temizle" (Filtreyi Kapat solu, tum filtreleri temizler)
    if (header && !header.querySelector('.tcft-clearall-head')) {
      var ca = document.createElement('a'); ca.className = 'tcft-clearall-head';
      ca.href = '/collections/' + handle; ca.textContent = L('Tümünü Temizle', 'Clear All');
      var cbtn = header.querySelector('.halo-sidebar-close');
      if (cbtn) header.insertBefore(ca, cbtn); else header.appendChild(ca);
    }
    var shell = wrap.querySelector('.tcft-shell');

    if (!shell) {
      shell = document.createElement('div'); shell.className = 'tcft-shell';
      var rail = document.createElement('div'); rail.className = 'tcft-rail';
      var body = document.createElement('div'); body.className = 'tcft-body';
      shell.appendChild(rail); shell.appendChild(body);

      var toggles = document.createElement('div'); toggles.className = 'tcft-toggles';
      function tgl(label, tag) {
        var on = new RegExp('/' + tag + '(?:/|$)').test(location.pathname);
        return '<a class="tcft-toggle' + (on ? ' is-on' : '') + '" href="/collections/' + handle + (on ? '' : '/' + tag) + '"><span class="tcft-sw"></span>' + label + '</a>';
      }
      toggles.innerHTML = tgl(L('İndirimli Ürünler', 'On Sale'), 'indirimli') + tgl(L('Hızlı Teslimat', 'Fast Delivery'), 'hizli-teslimat');
      var refined = sb.querySelector('.refined-widgets'); if (refined) rail.appendChild(refined); // aktif filtreler rail basina (bosluk gider)
      rail.appendChild(toggles);

      TABS.forEach(function (tab) {
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'tcft-tab tcft-tab--empty tcft-tab--' + tab.k;
        btn.innerHTML = '<span class="tcft-tab-lbl">' + (EN ? tab.e : tab.t) + '</span>'; // rozet yok
        var pane = document.createElement('div'); pane.className = 'tcft-pane tcft-pane--' + tab.k;
        pane.innerHTML = '<div class="tcft-empty">' + L('Bu koleksiyonda bu filtre bulunmuyor.', 'No filters available in this collection.') + '</div>';
        rail.appendChild(btn); body.appendChild(pane);
        btn.addEventListener('click', function () { activate(rail, body, btn, pane); });
      });

      var foot = document.createElement('div'); foot.className = 'tcft-foot';
      var clearLink = sb.querySelector('.refined-widgets .facets__clear-all');
      foot.innerHTML =
        '<div class="tcft-foot-right"><span class="tcft-count"></span><button type="button" class="tcft-apply">' + L('FİLTRELERİ UYGULA', 'APPLY FILTERS') + '</button></div>';
      // ONEMLI: shell'i FORM icine koy ki native filtre input'lari (Marka/Fiyat/Stok) form descendant kalsin -> AJAX calissin
      var formEl = sb.querySelector('#CollectionFiltersForm');
      (formEl || wrap).appendChild(shell);
      wrap.appendChild(foot);
      foot.querySelector('.tcft-apply').addEventListener('click', function () { document.body.classList.remove('tcb-filter-open'); });
      if (FTEST) setTimeout(function () { document.body.classList.add('tcb-filter-open'); }, 120); // yayinda FILTRELE butonu acar (base JS openF)
    }

    var rail = shell.querySelector('.tcft-rail'), body = shell.querySelector('.tcft-body');
    // bloklari ilgili sekmeye senkronize tasi
    collectBlocks(sb).forEach(function (b) {
      var k = keyOf(titleOf(b)); var pane = body.querySelector('.tcft-pane--' + k);
      if (!pane || pane.contains(b)) return;
      var em = pane.querySelector('.tcft-empty'); if (em) em.remove();
      if (pane.querySelector('.sidebarBlock, .sidebar-custom-text')) return; // ayni key'den bir blok yeter
      b.querySelectorAll('.sidebarBlock-contentWrapper').forEach(function (cw) { cw.style.display = 'block'; });
      pane.appendChild(b);
      var btn = rail.querySelector('.tcft-tab--' + k); if (btn) btn.classList.remove('tcft-tab--empty');
    });
    // sonuc sayisi guncelle
    var cEl = sb.querySelector('.results-count .count'); var cnt = cEl ? cEl.textContent.trim() : '';
    var cBox = shell.parentNode.querySelector('.tcft-count'); if (cBox && cnt) cBox.innerHTML = '<b>' + cnt + '</b> ' + L('Sonuç', 'Results');
    // tum filtre ogelerini ac (max_item gizlemesini kaldir) -> markalarin HEPSI gorunsun
    shell.querySelectorAll('.tcft-pane .facets__item.d-none').forEach(function (li) { li.classList.remove('d-none'); li.style.opacity = ''; });
    // 0 sonuclu (disabled) marka/stil/ortam da secilebilir olsun -> kullanici suzebilsin
    shell.querySelectorAll('.tcft-pane .facets__item input[disabled]').forEach(function (i) { i.disabled = false; });
    // NOTA coklu secim kurulumu (tik + cipleri toggle yap)
    var notaPane = body.querySelector('.tcft-pane--nota');
    if (notaPane && notaPane.querySelector('.tcb-nota__chip') && !notaPane.querySelector('.tcft-nota-bar')) {
      var nb = document.createElement('div'); nb.className = 'tcft-nota-bar';
      nb.innerHTML =
        '<p class="tcft-nota-desc">' + L('Çoklu nota için bir mod seç, notalara tıkla (birikir), sonra <b>Çoklu Filtrele</b>’ye bas. Mod seçmezsen tek notaya tıklayınca anında uygulanır.', 'For multiple notes, pick a mode, click notes (they stack), then press <b>Filter Multiple</b>. Without a mode, clicking a single note applies instantly.') + '</p>' +
        '<label class="tcft-nota-mode"><input type="radio" name="tcftnotamode" value="and"> ' + L('Tek parfümde çoklu nota seçimi', 'Multiple notes in one perfume') + ' <small>' + L('(ve)', '(and)') + '</small></label>' +
        '<label class="tcft-nota-mode"><input type="radio" name="tcftnotamode" value="or"> ' + L('Çoklu notalardaki tüm parfümler', 'All perfumes across multiple notes') + ' <small>' + L('(veya)', '(or)') + '</small></label>' +
        '<button type="button" class="tcft-nota-apply">' + L('Çoklu Filtrele', 'Filter Multiple') + '</button>';
      var t = notaPane.querySelector('.tcb-flt-title');
      if (t) t.parentNode.insertBefore(nb, t.nextSibling); else notaPane.insertBefore(nb, notaPane.firstChild);
      notaPane.querySelectorAll('.tcb-nota__chip').forEach(function (chip) {
        chip.addEventListener('click', function (e) {
          if (chip.classList.contains('is-active')) return; // secili -> deselect link
          var mode = notaPane.querySelector('input[name="tcftnotamode"]:checked');
          if (mode) { e.preventDefault(); chip.classList.toggle('tcft-sel'); } // mod secili -> coklu toggle
          // mod yok: normal link -> tek nota aninda
        });
      });
      nb.querySelector('.tcft-nota-apply').addEventListener('click', function () {
        var modeEl = notaPane.querySelector('input[name="tcftnotamode"]:checked');
        var sel = [].slice.call(notaPane.querySelectorAll('.tcb-nota__chip.tcft-sel'));
        if (!sel.length) { alert(L('Önce bir mod seçip notalara tıklayın.', 'First pick a mode, then click notes.')); return; }
        var nbase = '/collections/' + handle;
        var nexist = (location.pathname.indexOf(nbase + '/') === 0) ? location.pathname.slice((nbase + '/').length).split('+').filter(Boolean) : [];
        if (modeEl && modeEl.value === 'or') {
          // VEYA: mevcut path-tag'leri KORU + filter.p.tag ile notalar (S&D etiket filtresi gerekir) + native KORU
          window.location.href = location.pathname + '?' + sel.map(function (c) { return 'filter.p.tag=' + encodeURIComponent(c.textContent.trim()); }).join('&') + '&' + nativeQS();
        } else {
          // VE: secili notalari mevcut secimlere EKLE (birikir); Marka/Fiyat/Stokta KORU
          sel.forEach(function (c) { var t = c.getAttribute('href').split('/').pop(); if (nexist.indexOf(t) < 0) nexist.push(t); });
          window.location.href = nbase + '/' + nexist.join('+') + '?' + nativeQS();
        }
      });
    }
    // aktif path-tag'leri (Kadin/Renk/Nota/Stil) NATIVE refined listesine ekle:
    // Fiyat/Marka cipleriyle AYNI tipoloji (duz yazi + x) + AYNI serit. Native query (marka/fiyat) KORUNUR.
    var refinedUl = sb.querySelector('.refined-widgets .facets__list--refined');
    var refinedW = sb.querySelector('.refined-widgets');
    if (refinedUl) {
      var atBase = '/collections/' + handle;
      var atPart = (location.pathname.indexOf(atBase + '/') === 0) ? location.pathname.slice((atBase + '/').length) : '';
      var atTags = atPart ? atPart.split('+').filter(Boolean) : [];
      // SADECE tag listesi degistiyse yeniden olustur -> MutationObserver dongusu/blink YOK
      var curKey = [].map.call(refinedUl.querySelectorAll('.tcft-pathtag-li'), function (li) { return li.getAttribute('data-tag'); }).join('+');
      if (curKey !== atTags.join('+')) {
        refinedUl.querySelectorAll('.tcft-pathtag-li').forEach(function (x) { x.remove(); });
        atTags.forEach(function (tg) {
          var lbl = decodeURIComponent(tg);
          var m = [].slice.call(shell.querySelectorAll('.tcb-renk__chip.is-active')).filter(function (c) { return norm(c.textContent).replace(/\s+/g, '-') === tg; })[0];
          if (m) lbl = m.textContent.trim();
          var li = document.createElement('li'); li.className = 'tcft-pathtag-li'; li.setAttribute('data-tag', tg);
          var a = document.createElement('a'); a.className = 'active-facets__button'; a.href = '#';
          a.innerHTML = '<span class="text"></span><span class="close"></span>';
          a.querySelector('.text').textContent = lbl;
          li.appendChild(a); refinedUl.appendChild(li);
        });
        if (refinedW && atTags.length) refinedW.style.display = '';
      }
    }
    applyVisibility(rail, body);
  }

  // koleksiyona gore sekme gorunurlugu (rozet yerine direkt goster/gizle)
  function applyVisibility(rail, body) {
    var path = location.pathname;
    var isPerfume = /parfum|perfume|kozmetik|cosmetic/i.test(path);
    var isWatch = /saat|kol-saati|watch/i.test(path);
    var ALWAYS = { marka: 1, fiyat: 1, stok: 1, cinsiyet: 1 };
    ['marka', 'cinsiyet', 'kategori', 'beden', 'renk', 'fiyat', 'nota', 'stil', 'ortam', 'kordon', 'stok'].forEach(function (k) {
      var btn = rail.querySelector('.tcft-tab--' + k), pane = body.querySelector('.tcft-pane--' + k);
      if (!btn || !pane) return;
      var empty = btn.classList.contains('tcft-tab--empty');
      var hide = false;
      if (k === 'nota') hide = !isPerfume;                 // NOTA sadece parfum
      else if (k === 'kordon') hide = !isWatch;            // KORDON sadece saat
      else if (k === 'renk') hide = isPerfume;             // RENK parfumde gizli
      else if (k === 'stil' || k === 'ortam') hide = isPerfume || isWatch; // STIL/ORTAM sadece giyim/elbise
      else if (!ALWAYS[k]) hide = empty;                   // kategori/beden: bos ise gizle
      btn.style.display = hide ? 'none' : '';
    });
    // ?tab=nota gibi parametre ile o sekmeyi ac (test + link kolayligi)
    var wantTab = (location.search.match(/[?&]tab=([a-z]+)/) || [])[1];
    if (wantTab && !rail.dataset.tabForced) {
      var wb = rail.querySelector('.tcft-tab--' + wantTab);
      if (wb && wb.style.display !== 'none') { wb.click(); rail.dataset.tabForced = '1'; }
    }
    // aktif sekme gizli/yoksa ilk gorunur sekmeye gec
    var act = rail.querySelector('.tcft-tab.is-active');
    if (!act || act.style.display === 'none') {
      var vis = [].slice.call(rail.querySelectorAll('.tcft-tab')).filter(function (b) { return b.style.display !== 'none'; });
      var pick = vis.filter(function (b) { return !b.classList.contains('tcft-tab--empty'); })[0] || vis[0];
      if (pick) pick.click();
    }
  }

  function place() {
    var btn = document.querySelector('.collection-full-width .toolbar .toolbar-sidebar') || document.querySelector('.toolbar .toolbar-sidebar');
    if (!btn) return;
    var r = btn.getBoundingClientRect();
    var W = Math.min(1080, window.innerWidth * 0.94);
    var left = r.left; if (left + W > window.innerWidth - 12) left = window.innerWidth - W - 12; if (left < 12) left = 12;
    document.documentElement.style.setProperty('--tcft-left', Math.round(left) + 'px');
    document.documentElement.style.setProperty('--tcft-top', Math.round(r.bottom + 8) + 'px');
  }
  function tick() { ensure(); place(); }
  if (document.readyState !== 'loading') setTimeout(tick, 60); else document.addEventListener('DOMContentLoaded', tick);
  window.addEventListener('load', tick);
  // PERF: panel KAPALIYKEN scroll'da yeniden konumlandirma gereksiz -> sadece acikken calistir
  window.addEventListener('scroll', function () { if (document.body.classList.contains('tcb-filter-open')) place(); }, { passive: true });
  window.addEventListener('resize', place);
  document.addEventListener('click', function () { setTimeout(place, 0); }, true);
  var deb; var mo = new MutationObserver(function () { clearTimeout(deb); deb = setTimeout(tick, 80); });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // GATED TEST: panel ici koleksiyon linklerine tiklayinca ?ftabs=1 koru (sekmeli menu kaybolmasin).
  // Yayina alindiginda (gate kalkinca) bu satir gereksiz olur, zararsizdir.
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;                  // NOTA mod-toggle gibi preventDefault edilmis -> dokunma
    // aktif filtre seridindeki path-tag cipi (native facet degil) -> carpiya basinca KALDIR
    var af = e.target.closest('#halo-sidebar .refined-widgets a.active-facets__button');
    if (af && !af.classList.contains('js-facet-remove')) {
      e.preventDefault();
      var liTag = af.closest('.tcft-pathtag-li');
      if (liTag) {
        // path-tag cipi (Kadin/Renk/Nota) -> o tag'i CIKAR, kalan tag + guncel native filtreleri koru
        var rmTag = liTag.getAttribute('data-tag');
        var b = (location.pathname.match(/^(\/collections\/[^\/?]+)/) || [])[1];
        var ex = (location.pathname.indexOf(b + '/') === 0) ? location.pathname.slice((b + '/').length).split('+').filter(Boolean) : [];
        ex = ex.filter(function (x) { return x !== rmTag; });
        window.location.href = (ex.length ? b + '/' + ex.join('+') : b) + '?' + nativeQS();
      } else {
        window.location.href = af.getAttribute('href');
      }
      return;
    }
    var base = (location.pathname.match(/^(\/collections\/[^\/?]+)/) || [])[1];
    // custom filtre cipi (RENK/NOTA/CINSIYET/STIL/ORTAM) -> mevcut secimlere EKLE/CIKAR (birikir, ustune yazmaz)
    var chip = e.target.closest('#halo-sidebar .tcb-renk__chip, #halo-sidebar .tcb-nota__chip');
    if (chip && base) {
      e.preventDefault();
      var existing = (location.pathname.indexOf(base + '/') === 0) ? location.pathname.slice((base + '/').length).split('+').filter(Boolean) : [];
      var tag = (chip.getAttribute('href') || '').split('?')[0].split('/').pop();
      var idx = existing.indexOf(tag);
      if (idx > -1 || chip.classList.contains('is-active')) { if (idx > -1) existing.splice(idx, 1); } // zaten varsa cikar
      else existing.push(tag);                                                                          // yoksa ekle
      window.location.href = (existing.length ? base + '/' + existing.join('+') : base) + '?' + nativeQS(); // Marka/Fiyat/Stokta KORU
      return;
    }
    // TEST modunda (?ftabs=1) panel ici koleksiyon linklerine ftabs=1 koru (auto-open test akisi bozulmasin).
    // YAYINDA: dokunma, linkler normal gitsin (temiz URL).
    if (!FTEST) return;
    var a = e.target.closest('#halo-sidebar a[href^="/collections/"]');
    if (!a) return;
    var h = a.getAttribute('href') || '';
    if (h.indexOf('ftabs=1') > -1) return;
    e.preventDefault();
    window.location.href = h + (h.indexOf('?') < 0 ? '?' : '&') + 'ftabs=1';
  });
})();
